import React from 'react';
import { useLocation } from 'react-router-dom';

export const WithLocation = (BaseComponent) => {
  const LocationComponent = (props) => {
    const location = useLocation();
    return (
      <BaseComponent
        location={location}
        {...props}
      />
    );
  };

  // No need for contextTypes anymore!

  return LocationComponent;
};
